import React, {useState} from 'react'
import {Calendar} from 'grommet/components/Calendar'
import {DropButton} from 'grommet/components/DropButton'
import {TextInput} from 'grommet/components/TextInput'
import Icons from '../../../components/Icons'
import styled from 'styled-components'
import {useLocaleState} from '../../../context/LocaleContext'

const CalendarField = ({date, onSelect, bounds}) => {
  const [open, setOpen] = useState(false)
  const {locale} = useLocaleState()

  const doSelect = date => {
    setOpen(false)
    onSelect(date)
  }

  const dateFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }

  return (
    <StyledDropButton
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      dropContent={
        <CalendarContainer>
          <Calendar
            date={date}
            onSelect={doSelect}
            locale={locale}
            bounds={bounds}
          />
        </CalendarContainer>
      }
    >
      <Container>
        <StyledTextInput
          value={
            date
              ? new Date(date).toLocaleDateString(locale, dateFormatOptions)
              : new Date().toLocaleDateString(locale, dateFormatOptions)
          }
        />
        <StyledButton data-testid="calendar-field-button">
          <Icons icon="CALENDAR" />
        </StyledButton>
      </Container>
    </StyledDropButton>
  )
}

const getDefaultBounds = () => {
  const now = new Date()
  const start = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0
  )
  const end = new Date(
    now.getFullYear() + 2,
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0
  )
  return [start.toISOString(), end.toISOString()]
}

CalendarField.defaultProps = {
  onSelect: () => {},
  date: new Date(),
  locale: 'en-US',
  bounds: getDefaultBounds()
}

export default CalendarField

const Container = styled.div`
  display: flex;
`
const CalendarContainer = styled.div`
  padding: 20px;
  
  @media (max-width: 420px) {
    padding: 0px;
  }
`

const StyledTextInput = styled(TextInput)`
  border: none;
  border-radius: 6px;
  background-color: #f4f5fa;
  font-weight: 600;
  color: #000000;
  padding: 12px 12px 12px 20px;
  font-size: 16px;
`
const StyledButton = styled.div`
  border: none;
  box-shadow: 0 1px 6px 0 rgba(51, 149, 254, 0.38);
  border-radius: 4px;
  width: 46px;
  height: 46px;
  padding: 12px;
`

const StyledDropButton = styled(DropButton)`
  width: 100%;
`
